export default __webpack_public_path__ + "static/media/Img008.bb7013ab.jpg";